import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WorkItemDetailComponent } from './work-item-detail.component';

const routes: Routes = [{
  path: 'detail/:id',
  component: WorkItemDetailComponent
}, {
  path: ':id',
  component: WorkItemDetailComponent
}];


export class WorkItemDetailRoutingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
